const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjQxNDIxIDEyTDE2LjcwNzEgMTkuMjkyOUwxNS4yOTI5IDIwLjcwNzFMNi41ODU3OCAxMkwxNS4yOTI5IDMuMjkyOTFMMTYuNzA3MSA0LjcwNzEyTDkuNDE0MjEgMTJaIi8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=arrow_left-0d649723.mjs.map
